export const getBrowserTheme = () => {
  if (!window?.matchMedia) {
    return 'Unknown';
  }
  return window.matchMedia('(prefers-color-scheme:dark)').matches ? 'DarkMode' : 'LightMode';
};
